import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 搜索组件属性接口 */
export type SearchAttrs = BaseComponentAttrs;

/** 搜索组件类 */
export class SearchComponent extends BaseComponent<SearchAttrs> {
  constructor(data: Partial<BaseComponent<SearchAttrs>> = {}) {
    super(data);
    this.type = CompType.search;
  }
}
